/** User-facing release strings — keep `APP_VERSION_SEMVER` in sync with `frontend/package.json` "version". */
export const APP_VERSION_SEMVER = '1.3.76';
export const APP_VERSION_LABEL = 'v1.3.76';
